export const popupMessagesTutorialStart = [
  {
    name: 'Bailey',
    text: 'Welcome! I\'m Bailey, and this is Benny!',
    alignment: 'left'
  },
  {
    name: 'Benny',
    text: 'Here at Ledger Legends, we\'re all about helping small businesses navigate the twists and turns of their financial journey.',
    alignment: 'right'
  },
  {
    name: 'Bailey',
    text: 'Today is training day! Your assignment is to explore the financial data of one of our clients, Emma, the owner of <b>Bean Counter</b>. Since you\'re new, this will be a simulated experience.',
    alignment: 'left'
  },
  {
    name: 'Benny',
    text: 'We want to see how well you understand the core principles, assumptions, and constraints that drive financial reporting.',
    alignment: 'right'
  },
  {
    name: 'Bailey',
    text: 'Ready to dive into the world of numbers with us?',
    alignment: 'left'
  },
];

export const popupMessagesTutorialEnd = [
  {
    name: 'Bailey',
    text: 'Nice work! $500 would be the correct profits. Here’s your Mastery Skills Index Score:  1500',
    alignment: 'left'
  },
  {
    name: 'Benny',
    text: 'Now it’s time to introduce you to Emma and her small business <b>Bean Counter</b>, a vibrant coffee shop in the heart of Universe town',
    alignment: 'right'
  }
];

export const popupMessagesSummary = [
  {
    name: 'Bailey',
    text: 'You achieved a {accuracy} accuracy, averaged {averageTime} per decision, and earned a total of {points} points, earning your Accounting {rank} status.'
  }
];

export const tutorialTransactions = [
  {
    id: 1,
    description: 'Let’s assume you have a business and in the month of January, you received $1,000 in cash from selling and delivering your product to various customers.',
    value: 1000,
    explanation: 'Under ""Revenue Recognition principle"", the sales would be recorded as revenues and would increase profits. Click Next to continue.'
  },
  {
    id: 2,
    description: 'Let’s assume the product that you sold costs you $500 to make.',
    value: 500,
    explanation: 'Under Matching principles, this is an expense and it should be recorded in the same accounting period of the associated sale. Click Next to continue.'
  }
];

export const tutorialAnswers = [
  {
    id: 1,
    answer: 'Increase Profits'
  },
  {
    id: 2,
    answer: 'Decrease Profits'
  }
];

export const popupMessagesGameStart = [
  {
    name: 'Emma',
    text: 'Hey there! Welcome to Retail Therapy. I\'m Emma.',
    alignment: 'left'
  },
  {
    name: 'Emma',
    text: 'I need your help in putting together my financial numbers for the month.  Investors are asking about monthly profits and I have no idea if I’m even profitable.',
    alignment: 'left'
  },
  {
    name: 'Emma',
    text: 'Could you review our business activity for the month and let us know if we’re profitable?',
    alignment: 'left'
  }
];

export const popupMessagesGameEnd = [
  {
    name: 'Emma',
    text: 'Thanks, {name}! Your help saved me so much time! I now have a better grasp of my performance and can convey that to investors.',
    alignment: 'left'
  },
  {
    name: 'Benny',
    text: 'Nice work {name}!',
    alignment: 'right'
  },
  {
    name: 'Bailey',
    text: 'It’s review time!',
    alignment: 'left'
  }
];

export const transactionsAnswerOptions = [
  'Increase Profits',
  'Decrease Profits',
  'No Impact'
];

export const popupMessagesPeerBenchmark = [
  {
    name: 'Benny',
    text: 'Here’s how you perform in relation to others',
    alignment: 'left'
  }
];

export const popupMessagesPrinciplesMastery = [
  {
    name: 'Bailey',
    text: 'Here’s how well you understood each of the principles, assumptions, and/or constraints that appeared in the task',
    alignment: 'left'
  }
];

export const popupMessagesSummaryBreakdown = [
  {
    name: 'Bailey',
    text: '<br>In this activity, you\'re practicing a key accounting skill: figuring out when a transaction should impact profit.  This is the heart of accrual accounting, and it’s guided by two essential principles:<br><br><h3>Revenue Recognition Principles</h3><p>Record revenue when it’s earned, not necessarily when the cash comes in. If a company delivers a product or service, that’s the moment it counts as income, even if the payment happens later.</p><br><h3>Expense Recognition Principles</h3><p>Record expenses when the related goods or services are used, not just when the bill is paid. This ensures expenses are matched to the revenue they helped generate.</p><br><p>Mastering these two principles will give you a strong foundation, not just for this exercise, but for your entire accounting course. They’re the building blocks of how real companies report their financial performance.</p><br>'
  }
];

export const popupMessagesSummaryApc = [
  {
    name: 'Bailey',
    text: '<br>Let\'s connect the dots on what you just practiced. Principles, Assumptions, and Constraints form the foundation of financial accounting. Nail these concepts now and everything that comes next in your course gets easier.<br><br><p><strong>Assumptions</strong> are the basic conditions we accept as true about a business. Without them, you can\'t report on a business without first agreeing on what it is, how to measure it, and whether it\'ll still exist next year.</p><br><p><strong>Principles</strong> are the guidelines accountants follow to record activity accurately. They ensure consistency, so investors, lenders, and managers can trust and compare what they\'re reading.</p><br><p><strong>Constraints</strong> are the real-world limits on how strictly we apply the principles. They keep businesses from wasting resources on trivial precision while protecting users from overly optimistic reporting.</p><br><p><strong>How It All Ties Together:</strong> Think of it like building a house. Assumptions are the foundation. Principles are the blueprints, the rules for how everything gets constructed. Constraints are the building codes, the limits that keep things safe, honest, and useful.</p><br>'
  }
];

// Canonical item names for the Assumptions, Principles, and Constraints
// summary page. These must match `item_name` from
// /api/principles/scores/insights/ for name-based lookup.
export const summaryApcCategories = [
  { key: 'Assumptions', items: ['Economic Entity', 'Monetary Unit', 'Periodicity', 'Going Concern'] },
  { key: 'Principles',  items: ['Revenue Recognition', 'Expense Recognition (Matching)', 'Historical Cost', 'Full Disclosure'] },
  { key: 'Constraints', items: ['Cost-Benefit', 'Materiality', 'Conservatism'] },
];

export const popupMessagesSummaryDecisionBreakdown = [
  {
    name: 'Bailey',
    text: 'Here’s how you approach each transaction, deciding whether the transaction immediately impact profits or not.',
    alignment: 'top'
  }
];

export const summaryDecisionBreakdownElementsHeaders = [
  'Impact on Profits'
];

export const gameQuestionsLimit = 10;